import DaySeparateReportPage from './DaySeparateReportPage';

export default DaySeparateReportPage;
